module.exports = __webpack_public_path__ + "img/碳资产管理@1x.36b1b5a0.png";